// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.helperText__YI_7e {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: var(--inputs-error-text-helper);
  margin-top: 4px;
  min-height: 11px;
}
@media (max-width: 850px) {
  .helperText__YI_7e {
    font-size: 8px;
    line-height: 8px;
    margin-top: 2px;
    min-height: 8px;
  }
}

.textareaWrapper__aZdYX {
  position: relative;
}

.textArea__lISj6 {
  border-radius: 5px;
  font-size: 12px;
  line-height: 18px;
  color: var(--inputs-filled-text);
  width: 100%;
  max-height: 400px;
  border: 1px solid var(--inputs-default-stroke);
  background: var(--inputs-filled-filled-surface);
  outline: 0;
  box-shadow: none;
  padding: 8px;
  resize: none;
}
.textArea__lISj6:active {
  border: 1px solid var(--inputs-focus-stroke);
  background: var(--inputs-default-surface-default);
}
.textArea__lISj6:focus-visible {
  border: 1px solid var(--inputs-focus-stroke);
  background: var(--inputs-default-surface-default);
}
.textArea__lISj6::placeholder {
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 11px;
  line-height: 12px;
  letter-spacing: 0%;
  color: var(--inputs-default-text);
}
.textArea__lISj6:disabled {
  color: var(--inputs-disable-text);
  border: unset;
  background: var(--inputs-disable-disable-surface);
}

.textAreaFilledField__cjH47 {
  border: 1px solid var(--inputs-filled-stroke);
  background: var(--inputs-filled-filled-surface);
}

.textAreaErrorField__NUIWj {
  border: 1px solid var(--inputs-error-stroke);
  background: var(--inputs-error-error-surface);
}

.rightIndent__j7h2s {
  padding-right: 35px;
}

.inputHeader__mehIm {
  position: relative;
  margin-bottom: 5px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.label__S5aP6 {
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}

.required__BcIcE:after {
  content: "*";
  font-size: 10px;
  line-height: 12px;
  color: var(--inputs-error-text-helper);
  margin-left: 4px;
}

.inputDetailsWrapper__jchtX {
  margin-left: auto;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.inputDetailsIcon__ZFY_L {
  width: 100%;
  height: 100%;
  fill: var(--buttons-surface);
}

.inputDetails__LnyPU {
  max-width: 453px;
  padding: 8px !important;
  opacity: 1 !important;
  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));
  border-radius: 4px !important;
  text-align: left !important;
}`, "",{"version":3,"sources":["webpack://./../src/components/form/TextArea/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;AAzEF;AA2EE;EARF;IASI,cAAA;IACA,gBAAA;IACA,eAAA;IACA,eAAA;EAxEF;AACF;;AA2EA;EACE,kBAAA;AAxEF;;AA2EA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,WAAA;EACA,iBAAA;EACA,8CAAA;EACA,+CAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;AAxEF;AA0EE;EACE,4CAAA;EACA,iDAAA;AAxEJ;AA2EE;EACE,4CAAA;EACA,iDAAA;AAzEJ;AA4EE;EACE,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iCAAA;AA1EJ;AA6EE;EACE,iCAAA;EACA,aAAA;EACA,iDAAA;AA3EJ;;AA+EA;EACE,6CAAA;EACA,+CAAA;AA5EF;;AA+EA;EACE,4CAAA;EACA,6CAAA;AA5EF;;AA+EA;EACE,mBAAA;AA5EF;;AA+EA;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AA5EF;;AA+EA;EACE,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA5EF;;AAgFE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,gBAAA;AA7EJ;;AAiFA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AA9EF;;AAiFA;EACE,WAAA;EACA,YAAA;EACA,4BAAA;AA9EF;;AAiFA;EACE,gBAAA;EArIA,uBAAA;EACA,qBAAA;EACA,mDAAA;EACA,6BAAA;EACA,2BAAA;AAwDF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.helperText {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--inputs-error-text-helper);\n  margin-top: 4px;\n  min-height: 11px;\n\n  @media (max-width: 850px) {\n    font-size: 8px;\n    line-height: 8px;\n    margin-top: 2px;\n    min-height: 8px;\n  }\n}\n\n.textareaWrapper {\n  position: relative;\n}\n\n.textArea {\n  border-radius: 5px;\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--inputs-filled-text);\n  width: 100%;\n  max-height: 400px;\n  border: 1px solid var(--inputs-default-stroke);\n  background: var(--inputs-filled-filled-surface);\n  outline: 0;\n  box-shadow: none;\n  padding: 8px;\n  resize: none;\n\n  &:active {\n    border: 1px solid var(--inputs-focus-stroke);\n    background: var(--inputs-default-surface-default);\n  }\n\n  &:focus-visible {\n    border: 1px solid var(--inputs-focus-stroke);\n    background: var(--inputs-default-surface-default);\n  }\n\n  &::placeholder {\n    font-family: 'Roboto', sans-serif;\n    font-weight: 500;\n    font-size: 11px;\n    line-height: 12px;\n    letter-spacing: 0%;\n    color: var(--inputs-default-text);\n  }\n\n  &:disabled {\n    color: var(--inputs-disable-text);\n    border: unset;\n    background: var(--inputs-disable-disable-surface);\n  }\n}\n\n.textAreaFilledField {\n  border: 1px solid var(--inputs-filled-stroke);\n  background: var(--inputs-filled-filled-surface);\n}\n\n.textAreaErrorField {\n  border: 1px solid var(--inputs-error-stroke);\n  background: var(--inputs-error-error-surface);\n}\n\n.rightIndent {\n  padding-right: 35px;\n}\n\n.inputHeader {\n  position: relative;\n  margin-bottom: 5px;\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.label {\n  color: var(--title-inputs-sections-title);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n\n.required {\n  &:after {\n    content: '*';\n    font-size: 10px;\n    line-height: 12px;\n    color: var(--inputs-error-text-helper);\n    margin-left: 4px;\n  }\n}\n\n.inputDetailsWrapper {\n  margin-left: auto;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n.inputDetailsIcon {\n  width: 100%;\n  height: 100%;\n  fill: var(--buttons-surface);\n}\n\n.inputDetails {\n  max-width: 453px;\n  @include tooltip;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helperText": `helperText__YI_7e`,
	"textareaWrapper": `textareaWrapper__aZdYX`,
	"textArea": `textArea__lISj6`,
	"textAreaFilledField": `textAreaFilledField__cjH47`,
	"textAreaErrorField": `textAreaErrorField__NUIWj`,
	"rightIndent": `rightIndent__j7h2s`,
	"inputHeader": `inputHeader__mehIm`,
	"label": `label__S5aP6`,
	"required": `required__BcIcE`,
	"inputDetailsWrapper": `inputDetailsWrapper__jchtX`,
	"inputDetailsIcon": `inputDetailsIcon__ZFY_L`,
	"inputDetails": `inputDetails__LnyPU`
};
module.exports = ___CSS_LOADER_EXPORT___;
